
document.addEventListener("DOMContentLoaded", function() {
	/*
	(function(){
		const headerDrawerControl = document.getElementById('header-drawer-control');
		const artworkMetaDrawer = document.querySelector('.artwork-meta');
		if( ! headerDrawerControl || ! artworkMetaDrawer )
			return;

		// default drawer state
		var artworkMetaDrawerState = 'closed';

		const setArtworkMetaDrawerState = function(state){
			artworkMetaDrawerState = state;
			if( typeof window.sessionStorage === 'undefined' )
				return;
			window.sessionStorage.setItem('artworkMetaDrawerState', state);
		};

		const openArtworkMeta = function(){
			headerDrawerControl.classList.add('js-active');
			artworkMetaDrawer.classList.add('js-active');
			setArtworkMetaDrawerState('open');

		};
		const closeArtworkMeta = function(){
			headerDrawerControl.classList.remove('js-active');
			artworkMetaDrawer.classList.remove('js-active');
			setArtworkMetaDrawerState('closed');
		};

		// on page load, set state
		if( typeof window.sessionStorage !== 'undefined' ){
			let state = window.sessionStorage.getItem('artworkMetaDrawerState');

			if( state && (state !== artworkMetaDrawerState) ) {
				if(state==='closed') 
					closeArtworkMeta();
				else 
					openArtworkMeta();
			}
		}

		headerDrawerControl.addEventListener('click',function(e) {
			e.preventDefault();
			if( artworkMetaDrawerState==='open' ){
				closeArtworkMeta();
			} else {
				openArtworkMeta();
			}
		});
	})();
	*/

	(function(){
		const nav = document.querySelector('nav.main-nav');
		const toggler = document.getElementById('toggle-global-nav');

		const openNav = () => {
			nav.classList.add('js-active');
			toggler.classList.add('js-active');
		};
		const closeNav = () => {
			toggler.classList.remove('js-active');
			nav.classList.remove('js-active');
		};
		toggler.addEventListener('click',function(e){
			e.preventDefault();
			if( this.classList.contains('js-active') )
				closeNav();
			else
				openNav();
		});
	})();

	/**
	 * Zoom
	 */
	(function(){
		const id = 'zoomable-image';
		var el = document.getElementById(id);
		if( ! el )
			return;
		const toolbarEl = document.getElementById('zoomable-image-toolbar');

		const imgsrc = el.dataset.url;

		el.classList.add('js-loading');
		toolbarEl.classList.add('js-loading');

		var osdViewer = OpenSeadragon({
			element: el,
			toolbar: 'zoomable-image-toolbar',
			autoHideControls: false, // stops controls from only showing on mouse over
			prefixUrl: window.zoomVars.theme_root + '/im/',
			// maxZoomLevel: 99, // allows zooming past 100% pixel size
			navigationControlAnchor: OpenSeadragon.ControlAnchor.TOP_RIGHT,
			navImages: {
				zoomIn: {
					REST: 'zoomin.png',
					GROUP: 'zoomin.png',
					HOVER: 'zoomin_hover.png',
					DOWN: 'zoomin_hover.png',
				},
				zoomOut: {
					REST: 'zoomout.png',
					GROUP: 'zoomout.png',
					HOVER: 'zoomout_hover.png',
					DOWN: 'zoomout_hover.png',
				},
				home: {
					REST: 'refresh.png',
					GROUP: 'refresh.png',
					HOVER: 'refresh_hover.png',
					DOWN: 'refresh_hover.png',
				},
				fullpage: {
					REST: 'expand.png',
					GROUP: 'expand.png',
					HOVER: 'expand_hover.png',
					DOWN: 'expand_hover.png',
				}
			},
			tileSources: {
				type: 'image',
				url: imgsrc
			},
			animationTime: .5,
			springStiffness: 4,
			overlays: [],
			// gestureSettingsMouse: {
				// flickEnabled: true,
				// clickToZoom: false,
				// scrollToZoom: false,
				// dblClickToZoom: true,
			// },
			// showNavigator: true, // minimap
		});

		osdViewer.addOnceHandler('open', function(e){
			// image url is e.source.url
			e.eventSource.element.classList.remove('js-loading');
			toolbarEl.classList.remove('js-loading');
		});

	})();




});